import { isNumber } from '@lifk/utils'
import { ExpressionSpecification } from 'mapbox-gl'

export const getSymbolCaseStatement = (
  config: {
    filter?: ExpressionSpecification
    image?: string
    modulus?: number
    modulator?: ExpressionSpecification
  }[]
) => {
  const caseStatement: ExpressionSpecification = ['case']

  config.forEach(({ filter, modulus, modulator, image }) => {
    if (!filter || !image || !isNumber(modulus) || !modulator) return

    const modulate = !!modulus && !!modulator

    caseStatement.push(filter)
    caseStatement.push([
      'concat',
      image,
      modulate ? '-' : '',
      modulate ? ['to-string', ['%', modulator, modulus]] : ''
    ])
  })
  caseStatement.push('')

  return caseStatement
}
